import axios from 'axios'
import authHeader from 'srcReact/helpers/auth-header'
import { doRequestAxios } from 'srcReact/helpers/apiHelper'

export const moderationReportService = {
  getFlagReasons,
  getInfo,
  addFlag,
  flagAction,
  suspend,
  validate,
  reinstate
}

let cancel

function getFlagReasons() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }
  return doRequestAxios(`/v2/moderation/flag-reasons`, requestOptions)
}

function getInfo(id_organization, tab, filter, search, offset, quantity) {
  if (cancel !== undefined) {
    cancel()
  }

  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    cancelToken: new axios.CancelToken((c) => (cancel = c)),
    params: { id_organization, tab, filter, search, offset, quantity }
  }
  return doRequestAxios(`/v2/moderation/get-info`, requestOptions)
}

function addFlag(id_post, object_type, object_id, id_organization, id_flag_reason, additional_justification) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    params: { id_post, object_type, object_id, id_organization, id_flag_reason, additional_justification }
  }
  return doRequestAxios(`/v2/moderation/add-flag`, requestOptions)
}

function flagAction(id_flagged_post, object_type, object_id, action) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    params: { id_flagged_post, object_type, object_id, action }
  }
  return doRequestAxios(`/v2/moderation/flag-action`, requestOptions)
}

function suspend(moderationId, organizationId, message = '') {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    data: {
      moderation_id: moderationId,
      id_organization: organizationId,
      ...(message && message.length > 0 ? { suspension_message: message } : {})
    }
  }
  return doRequestAxios(`/v2/moderation/suspend`, requestOptions)
}

function validate(moderationId, organizationId) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    params: {
      moderation_id: moderationId,
      id_organization: organizationId
    }
  }
  return doRequestAxios(`/v2/moderation/validate`, requestOptions)
}

function reinstate(objectType, objectId) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    params: {
      object_type: objectType,
      object_id: objectId
    }
  }
  return doRequestAxios(`/v2/moderation/reinstate-request`, requestOptions)
}
